import { connect } from 'react-redux'

import { confirmCinemaSelect } from './reducer'

const mapStateToProps = (state) => {
    return {
        isOpen: state?.components?.cinemaSelect?.isOpen ?? false,
    }
}

const mapDispatchToProps = { confirmCinemaSelect }

const hocCinemaSelectWindow = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocCinemaSelectWindow
